import { InjectionToken } from '@angular/core';
import { TNotification, TUserNotification } from './notification.type';

export const NOTIFICATION_INPUT = new InjectionToken<TUserNotification>('notification');
